import { LoginData } from '../models/login.model';
import { AuthService } from '../services/auth.service';

import { readExternalChannelAccessFromSession } from './external-channel-access.util';

export function shouldAccessPendingOrders(
  loginData: LoginData | null | undefined,
  authService: AuthService
): boolean {
  if (authService.isFixaSession()) {
    return true;
  }

  if (readExternalChannelAccessFromSession()) {
    return true;
  }

  const first = loginData?.resources?.[0];
  return typeof first === 'string';
}
